import { combineReducers } from 'redux';
import TopicListItemsDto from 'src/api/topicListItemsDto';

import BreadcrumbItem from '../api/breadcrumbItem';
import CertificateContentPage from '../api/certificatesContentPageEntity';
import CompetencesContentPage from '../api/competencesPageEntity';
import ContentPage from '../api/contentPageEntity';
import EventItemDto from '../api/eventItemDto';
import EventItem from '../api/eventItemEntity';
import VttFooter from '../api/footerEntity';
import NewsCategory from '../api/newsCategoryEntity';
import NewsItemDto from '../api/newsItemDto';
import NewsItem from '../api/newsItemEntity';
import TopNavigationMenuItem from '../api/topNavigationMenuEntity';
import VttError from '../api/vttError';
import WelcomePageHeroBanner from '../api/welcomePageHeroBannerEntity';
import WelcomePageHighlightBlock from '../api/welcomePageHighlightBlockEntity';

import { breadcrumbItemsReducer } from './breadcrumb';
import { eventsAndNewsItemsReducer } from './eventsAndNewsItems';
import { footerReducer } from './footer';
import { httpReducer, IHttpState } from './http';
import { mainContentReducer } from './mainContent';
import { topNavigationMenuItemReducer } from './topNavigationMenuItems';
import { welcomePageContentReducer } from './welcomePageContent';

export interface IState {
  breadcrumb: {breadcrumbItems: BreadcrumbItem[], latestPageTitle: string, nextRouteLocationPathname: string};
  topNavigationMenu: { topNavigationMenuItems: TopNavigationMenuItem[], isMobileNavigationVisible: boolean };
  mainContent: {certificatesPageItem: CertificateContentPage, competencesPageItem: CompetencesContentPage, currentContentPage: ContentPage, errorDescription: VttError, cookieBannerVisible: boolean};
  welcomePageContent: { heroBanner: WelcomePageHeroBanner, mainHighlightItems: WelcomePageHighlightBlock[], subMainHighlightItems: WelcomePageHighlightBlock[], newsItems: NewsItem[] };
  eventsAndNewsItems: {latestSelectedNewsItem: NewsItem, latestSelectedEventItem: EventItem, newsItemDto: NewsItemDto, eventItemDto: EventItemDto, newsCategories: NewsCategory[], eventCategories: NewsCategory[], topicListItemsDto: TopicListItemsDto};
  http: IHttpState;
  footer: VttFooter;
};

export const state = combineReducers<IState>({
    breadcrumb: breadcrumbItemsReducer,
    eventsAndNewsItems: eventsAndNewsItemsReducer,
    footer: footerReducer,
    http: httpReducer,
    mainContent: mainContentReducer,
    topNavigationMenu: topNavigationMenuItemReducer,
    welcomePageContent: welcomePageContentReducer
    });

// startsWith sectionPolyfill
String.prototype.startsWith = function (searchString: string, position?: number): boolean  {
      return this.substr(!position || position < 0 ? 0 : +position, searchString.length) === searchString;
};


// WEBPACK FOOTER //
// ./src/reducers/index.ts